










import { Component, Prop, Vue } from "vue-property-decorator";
import Point from "@/utils/point";

@Component
export default class Ruler extends Vue {
  @Prop() private width!: number;
  @Prop() private height!: number;
  private start?: Point;
  private marked = false;

  select(e: MouseEvent) {
    if (!this.start) {
      this.start = { x: e.offsetX, y: e.offsetY };
    } else if (!this.marked) {
      this.$emit("marked", {
        start: this.start,
        end: { x: e.offsetX, y: e.offsetY }
      });
      this.marked = true;
    }
  }

  drawLine(e: MouseEvent) {
    if (this.start && !this.marked) {
      const context = this.context;
      if (context) {
        context.clearRect(0, 0, this.width, this.height);
        context.beginPath();
        context.moveTo(this.start.x, this.start.y);
        context.lineTo(e.offsetX, e.offsetY);
        context.stroke();
      }
    }
  }

  get context() {
    const canvas = this.$refs.canvas as HTMLCanvasElement;
    return canvas.getContext("2d");
  }
}
